<div id="simple-formly-table-add-remove">

    <formly-form [form]="formGroup"  [options]="options" [model]="model" [fields]="fields"></formly-form>

    <div class="table-area">
        <app-table-view
          *ngIf="model"
          [data]="dataList"
          [config]="tableConfig"
          (checkboxSelected)="getSelections($event)"
          [selections]="itemsToBeRemoved"
          [relative]="readonly"
          [disableOneRowSelection]="disableOneRowSelection">
        </app-table-view>
    </div>

    <!--keeping this commented as example for dictionary pattern to use template and finding translation pattern-->
    <!--<ng-template #dropDownDataTemplate let-data let-tableColumns="columnIdx">
      {{ data.id | dict: getDictionary(tableColumns) }}
    </ng-template>-->

    <ng-template #dropDownDataTemplate let-data let-tableColumns="columnIdx">
      <span innerHTML="{{ translateField(data.id | dict: getDictionary(tableColumns)) }}"></span>
    </ng-template>

    <ng-template #actionTemplate let-data>
      <app-generic-action-control [appendTo]="'app-simple-formly-table-add-remove'" [rawData]="data" [disabled]="disabled"></app-generic-action-control>
    </ng-template>

</div>
